<div class="about-page">
  <!-- Hero Banner -->
  <div class="hero-banner">
    <div class="hero-overlay"></div>
    <div class="hero-particles">
      <span></span><span></span><span></span><span></span><span></span>
    </div>
    <div class="hero-content">
      <div class="hero-badge">
        <i class="fas fa-university"></i>
      </div>
      <h1 class="hero-title">About Us</h1>
      <p class="hero-subtitle">Discover our heritage, vision, and unwavering commitment to pharmaceutical education</p>
      <div class="hero-divider">
        <span></span><i class="fas fa-mortar-pestle"></i><span></span>
      </div>
    </div>
  </div>

  <div class="container content-wrapper">

    <!-- Stats Ribbon -->
    <div class="stats-ribbon">
      <div class="stat-item">
        <div class="stat-icon-wrap stat-blue">
          <i class="fas fa-calendar-check"></i>
        </div>
        <div class="stat-data">
          <h3>1993</h3>
          <p>Established</p>
        </div>
      </div>
      <div class="stat-item">
        <div class="stat-icon-wrap stat-purple">
          <i class="fas fa-graduation-cap"></i>
        </div>
        <div class="stat-data">
          <h3>30+</h3>
          <p>Years in Pharmacy</p>
        </div>
      </div>
      <div class="stat-item">
        <div class="stat-icon-wrap stat-teal">
          <i class="fas fa-users"></i>
        </div>
        <div class="stat-data">
          <h3>1500+</h3>
          <p>Alumni Network</p>
        </div>
      </div>
      <div class="stat-item">
        <div class="stat-icon-wrap stat-gold">
          <i class="fas fa-award"></i>
        </div>
        <div class="stat-data">
          <h3>100%</h3>
          <p>Accreditation</p>
        </div>
      </div>
    </div>

    <!-- Leadership Section -->
    <section class="section-block leadership-section">
      <div class="section-header">
        <div class="section-icon"><i class="fas fa-landmark"></i></div>
        <div>
          <h2 class="section-heading">Our Legacy & Leadership</h2>
          <p class="section-subtext">The visionaries behind our institution</p>
        </div>
      </div>

      <div class="leadership-grid">
        <div class="leader-card founder-card">
          <div class="leader-card-glow"></div>
          <div class="leader-img-wrap">
            <img alt="Founder" src="./assets/img/college/Maharshi.jpg" class="leader-img">
            <div class="leader-ring"></div>
          </div>
          <div class="leader-details">
            <span class="leader-badge">Founder</span>
            <h4 class="leader-name">Late Shri. Shankarrao Mohite-Patil</h4>
            <p class="leader-org">Shikshan Prasarak Mandal, Akluj</p>
          </div>
        </div>

        <div class="leader-card institution-card">
          <div class="leader-card-glow"></div>
          <div class="leader-img-wrap">
            <img alt="Logo" src="./assets/img/college/logo.png" class="leader-img logo-img">
            <div class="leader-ring"></div>
          </div>
          <div class="leader-details">
            <span class="leader-badge institution-badge">Est. 1948</span>
            <h4 class="leader-name">Shikshan Prasarak Mandal, Akluj</h4>
            <p class="leader-org">Leading Educational Institution</p>
          </div>
        </div>

        <div class="leader-card president-card">
          <div class="leader-card-glow"></div>
          <div class="leader-img-wrap">
            <img alt="President" src="./assets/img/college/president.jpg" class="leader-img">
            <div class="leader-ring"></div>
          </div>
          <div class="leader-details">
            <span class="leader-badge president-badge">President</span>
            <h4 class="leader-name">Mr. Sangramsinh Jaysinh Mohite-Patil</h4>
            <p class="leader-org">Shikshan Prasarak Mandal, Akluj</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Heritage Section -->
    <section class="section-block heritage-section">
      <div class="section-header">
        <div class="section-icon"><i class="fas fa-scroll"></i></div>
        <div>
          <h2 class="section-heading">Our Heritage</h2>
          <p class="section-subtext">A legacy of excellence since 1948</p>
        </div>
      </div>

      <div class="heritage-timeline">
        <div class="timeline-item">
          <div class="timeline-dot"><i class="fas fa-seedling"></i></div>
          <div class="timeline-content">
            <h5>The Foundation</h5>
            <p>Late Sahakar Maharshi Shankarrao Mohite-Patil, the founder member, established Shikshan Prasarak Mandal Akluj in 1948 with the vision of transforming society through quality education. The College of Pharmacy (Poly.) was established in 1993 and has since become one of Maharashtra's leading pharmaceutical educational institutions.</p>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-dot"><i class="fas fa-building"></i></div>
          <div class="timeline-content">
            <h5>Growth & Reputation</h5>
            <p>Shikshan Prasarak Mandal (SPM) stands as one of Maharashtra's premier educational institutions. Founded by the dedicated Late Shankarrao Mohite-Patil in 1948, the institution has evolved and established a distinguished reputation across Maharashtra through the tireless efforts of its teaching and administrative staff, guided by visionary management.</p>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-dot"><i class="fas fa-book-open"></i></div>
          <div class="timeline-content">
            <h5>Diverse Education</h5>
            <p>SPM operates diverse educational institutions spanning pre-primary, primary, secondary, higher secondary education, and technical courses in pharmacy, agriculture, and engineering.</p>
          </div>
        </div>

        <div class="timeline-item">
          <div class="timeline-dot"><i class="fas fa-rocket"></i></div>
          <div class="timeline-content">
            <h5>Modern Leadership</h5>
            <p>Under the forward-thinking leadership of Chairman Mr. Sangramsinh Jaysinh Mohite-Patil, SPM has achieved remarkable progress. SPM's College of Pharmacy, Akluj was inaugurated in 1993, currently under his visionary guidance.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- College Information Section -->
    <section class="section-block info-section">
      <div class="section-header">
        <div class="section-icon"><i class="fas fa-info-circle"></i></div>
        <div>
          <h2 class="section-heading">College Information</h2>
          <p class="section-subtext">Key details at a glance</p>
        </div>
      </div>

      <div class="info-cards-grid">
        <div class="info-card">
          <div class="info-card-icon"><i class="fas fa-calendar-alt"></i></div>
          <div class="info-card-label">Year of Establishment</div>
          <div class="info-card-value">1993</div>
        </div>
        <div class="info-card">
          <div class="info-card-icon"><i class="fas fa-check-circle"></i></div>
          <div class="info-card-label">Approved By</div>
          <div class="info-card-value">PCI, AICTE, DTE, Govt. of Maharashtra</div>
        </div>
        <div class="info-card">
          <div class="info-card-icon"><i class="fas fa-id-card"></i></div>
          <div class="info-card-label">DTE Institute Code</div>
          <div class="info-card-value">6401</div>
        </div>
        <div class="info-card">
          <div class="info-card-icon"><i class="fas fa-id-badge"></i></div>
          <div class="info-card-label">MSBTE Institute Code</div>
          <div class="info-card-value">0252</div>
        </div>
        <div class="info-card">
          <div class="info-card-icon"><i class="fas fa-envelope"></i></div>
          <div class="info-card-label">Email</div>
          <div class="info-card-value">
            0252principal&#64;msbte.com<br>
            0252office&#64;msbte.com
          </div>
        </div>
      </div>
    </section>
  </div>
</div>